import { LocationActionTypes } from './actions';
import Constants from './constants';

const initialState = null;

export function locationReducer(state = initialState, action) {
  return action.type === LocationActionTypes.LOCATION_CHANGE ? action.payload : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: locationReducer,
};
